/*global module, require*/

const defaults = require('./defaults'),
	envConfig = require('./staging'),
	storageConfig = require('./drive'),
	config = {
		microsoftAppId: 'ef9b3427-781e-442f-9713-ef6ee99f2d04',
		mindmupCloudUrl: 'https://aws-staging.mindmup.com',
		CDNDistributionId: 'E1WDYPVHTIPAGG'
	};
module.exports = Object.assign({}, defaults, storageConfig, envConfig, config);
